/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ListTfxDraftsParams,
  SuccessResponseDTOListTfxDraftDTO,
  SuccessResponseDTOTfxDraftDTO,
  SuccessResponseDTOTfxUploadUrlDTO,
  SuccessResponseDTOVoid,
  TfxDraftRejectRequestDTO,
  TfxDraftUpsertRequestDTO,
  TfxPreviewAttachRequestDTO,
  TfxPreviewUploadUrlRequestDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Drafts sorted by last modified; mine=false shows everyone's (reviewer view).
 */
export const listTfxDrafts = (params?: ListTfxDraftsParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListTfxDraftDTO>({
    url: `/admin/api/tfx/drafts`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getListTfxDraftsQueryKey = (params?: ListTfxDraftsParams) => {
  return [`/admin/api/tfx/drafts`, ...(params ? [params] : [])] as const;
};

export const getListTfxDraftsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTfxDrafts>>,
  TError = unknown,
>(
  params?: ListTfxDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxDrafts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTfxDraftsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTfxDrafts>>> = ({ signal }) =>
    listTfxDrafts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTfxDrafts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTfxDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listTfxDrafts>>>;
export type ListTfxDraftsQueryError = unknown;

export function useListTfxDrafts<
  TData = Awaited<ReturnType<typeof listTfxDrafts>>,
  TError = unknown,
>(
  params: undefined | ListTfxDraftsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxDrafts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxDrafts>>,
          TError,
          Awaited<ReturnType<typeof listTfxDrafts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxDrafts<
  TData = Awaited<ReturnType<typeof listTfxDrafts>>,
  TError = unknown,
>(
  params?: ListTfxDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxDrafts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxDrafts>>,
          TError,
          Awaited<ReturnType<typeof listTfxDrafts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxDrafts<
  TData = Awaited<ReturnType<typeof listTfxDrafts>>,
  TError = unknown,
>(
  params?: ListTfxDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxDrafts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Drafts sorted by last modified; mine=false shows everyone's (reviewer view).
 */

export function useListTfxDrafts<
  TData = Awaited<ReturnType<typeof listTfxDrafts>>,
  TError = unknown,
>(
  params?: ListTfxDraftsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxDrafts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTfxDraftsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create or bump a draft (keyed by packageId + caller); re-upsert resets it to DRAFT.
 */
export const upsertTfxDraft = (
  tfxDraftUpsertRequestDTO: TfxDraftUpsertRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOTfxDraftDTO>({
    url: `/admin/api/tfx/drafts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tfxDraftUpsertRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getUpsertTfxDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTfxDraft>>,
    TError,
    { data: TfxDraftUpsertRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertTfxDraft>>,
  TError,
  { data: TfxDraftUpsertRequestDTO },
  TContext
> => {
  const mutationKey = ['upsertTfxDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertTfxDraft>>,
    { data: TfxDraftUpsertRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return upsertTfxDraft(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertTfxDraftMutationResult = NonNullable<Awaited<ReturnType<typeof upsertTfxDraft>>>;
export type UpsertTfxDraftMutationBody = TfxDraftUpsertRequestDTO;
export type UpsertTfxDraftMutationError = unknown;

/**
 * @summary Create or bump a draft (keyed by packageId + caller); re-upsert resets it to DRAFT.
 */
export const useUpsertTfxDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertTfxDraft>>,
      TError,
      { data: TfxDraftUpsertRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertTfxDraft>>,
  TError,
  { data: TfxDraftUpsertRequestDTO },
  TContext
> => {
  const mutationOptions = getUpsertTfxDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Presigned PUT for the draft's preview MP4 (owner only).
 */
export const createTfxDraftPreviewUploadUrl = (
  id: number,
  tfxPreviewUploadUrlRequestDTO: TfxPreviewUploadUrlRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOTfxUploadUrlDTO>({
    url: `/admin/api/tfx/drafts/${id}/preview-upload-url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tfxPreviewUploadUrlRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateTfxDraftPreviewUploadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>,
    TError,
    { id: number; data: TfxPreviewUploadUrlRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>,
  TError,
  { id: number; data: TfxPreviewUploadUrlRequestDTO },
  TContext
> => {
  const mutationKey = ['createTfxDraftPreviewUploadUrl'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>,
    { id: number; data: TfxPreviewUploadUrlRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTfxDraftPreviewUploadUrl(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTfxDraftPreviewUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>
>;
export type CreateTfxDraftPreviewUploadUrlMutationBody = TfxPreviewUploadUrlRequestDTO;
export type CreateTfxDraftPreviewUploadUrlMutationError = unknown;

/**
 * @summary Presigned PUT for the draft's preview MP4 (owner only).
 */
export const useCreateTfxDraftPreviewUploadUrl = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>,
      TError,
      { id: number; data: TfxPreviewUploadUrlRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTfxDraftPreviewUploadUrl>>,
  TError,
  { id: number; data: TfxPreviewUploadUrlRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateTfxDraftPreviewUploadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit for review: DRAFT to SUBMITTED (owner only).
 */
export const submitTfxDraft = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/drafts/${id}/submit`,
    method: 'PATCH',
  });
};

export const getSubmitTfxDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTfxDraft>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitTfxDraft>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['submitTfxDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitTfxDraft>>, { id: number }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return submitTfxDraft(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitTfxDraftMutationResult = NonNullable<Awaited<ReturnType<typeof submitTfxDraft>>>;

export type SubmitTfxDraftMutationError = unknown;

/**
 * @summary Submit for review: DRAFT to SUBMITTED (owner only).
 */
export const useSubmitTfxDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitTfxDraft>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitTfxDraft>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getSubmitTfxDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reject: SUBMITTED to REJECTED with a required reason.
 */
export const rejectTfxDraft = (id: number, tfxDraftRejectRequestDTO: TfxDraftRejectRequestDTO) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/drafts/${id}/reject`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: tfxDraftRejectRequestDTO,
  });
};

export const getRejectTfxDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectTfxDraft>>,
    TError,
    { id: number; data: TfxDraftRejectRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectTfxDraft>>,
  TError,
  { id: number; data: TfxDraftRejectRequestDTO },
  TContext
> => {
  const mutationKey = ['rejectTfxDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectTfxDraft>>,
    { id: number; data: TfxDraftRejectRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectTfxDraft(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectTfxDraftMutationResult = NonNullable<Awaited<ReturnType<typeof rejectTfxDraft>>>;
export type RejectTfxDraftMutationBody = TfxDraftRejectRequestDTO;
export type RejectTfxDraftMutationError = unknown;

/**
 * @summary Reject: SUBMITTED to REJECTED with a required reason.
 */
export const useRejectTfxDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectTfxDraft>>,
      TError,
      { id: number; data: TfxDraftRejectRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectTfxDraft>>,
  TError,
  { id: number; data: TfxDraftRejectRequestDTO },
  TContext
> => {
  const mutationOptions = getRejectTfxDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Record the uploaded preview key on the draft (owner only).
 */
export const attachTfxDraftPreview = (
  id: number,
  tfxPreviewAttachRequestDTO: TfxPreviewAttachRequestDTO,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/drafts/${id}/preview`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: tfxPreviewAttachRequestDTO,
  });
};

export const getAttachTfxDraftPreviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachTfxDraftPreview>>,
    TError,
    { id: number; data: TfxPreviewAttachRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachTfxDraftPreview>>,
  TError,
  { id: number; data: TfxPreviewAttachRequestDTO },
  TContext
> => {
  const mutationKey = ['attachTfxDraftPreview'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachTfxDraftPreview>>,
    { id: number; data: TfxPreviewAttachRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return attachTfxDraftPreview(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AttachTfxDraftPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachTfxDraftPreview>>
>;
export type AttachTfxDraftPreviewMutationBody = TfxPreviewAttachRequestDTO;
export type AttachTfxDraftPreviewMutationError = unknown;

/**
 * @summary Record the uploaded preview key on the draft (owner only).
 */
export const useAttachTfxDraftPreview = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachTfxDraftPreview>>,
      TError,
      { id: number; data: TfxPreviewAttachRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachTfxDraftPreview>>,
  TError,
  { id: number; data: TfxPreviewAttachRequestDTO },
  TContext
> => {
  const mutationOptions = getAttachTfxDraftPreviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Approve: SUBMITTED to APPROVED; the package publish and catalog rebuild run after the DB commit.
 */
export const approveTfxDraft = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/drafts/${id}/approve`,
    method: 'PATCH',
  });
};

export const getApproveTfxDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveTfxDraft>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveTfxDraft>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['approveTfxDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveTfxDraft>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveTfxDraft(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveTfxDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveTfxDraft>>
>;

export type ApproveTfxDraftMutationError = unknown;

/**
 * @summary Approve: SUBMITTED to APPROVED; the package publish and catalog rebuild run after the DB commit.
 */
export const useApproveTfxDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveTfxDraft>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveTfxDraft>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getApproveTfxDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Draft detail incl. signed preview URL.
 */
export const getTfxDraft = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOTfxDraftDTO>({
    url: `/admin/api/tfx/drafts/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetTfxDraftQueryKey = (id?: number) => {
  return [`/admin/api/tfx/drafts/${id}`] as const;
};

export const getGetTfxDraftQueryOptions = <
  TData = Awaited<ReturnType<typeof getTfxDraft>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxDraft>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTfxDraftQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTfxDraft>>> = ({ signal }) =>
    getTfxDraft(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTfxDraft>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTfxDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getTfxDraft>>>;
export type GetTfxDraftQueryError = unknown;

export function useGetTfxDraft<TData = Awaited<ReturnType<typeof getTfxDraft>>, TError = unknown>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxDraft>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTfxDraft>>,
          TError,
          Awaited<ReturnType<typeof getTfxDraft>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTfxDraft<TData = Awaited<ReturnType<typeof getTfxDraft>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxDraft>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTfxDraft>>,
          TError,
          Awaited<ReturnType<typeof getTfxDraft>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTfxDraft<TData = Awaited<ReturnType<typeof getTfxDraft>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxDraft>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Draft detail incl. signed preview URL.
 */

export function useGetTfxDraft<TData = Awaited<ReturnType<typeof getTfxDraft>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTfxDraft>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTfxDraftQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
